"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSessionDisplayName = getSessionDisplayName;
/**
 * Returns the canonical display name for a session.
 * Priority: manual name → git branch/commit/tag → creation datetime
 */
function getSessionDisplayName(session) {
    // Priority 1: manual name
    if (session.name !== null &&
        session.name !== undefined &&
        session.name.trim().length > 0) {
        return { type: 'name', value: session.name.trim() };
    }
    // Priority 2: git info
    if ((session.git_branch !== null && session.git_branch !== undefined) ||
        (session.git_commit_message !== null &&
            session.git_commit_message !== undefined) ||
        (session.git_tag !== null && session.git_tag !== undefined)) {
        return {
            type: 'git',
            branch: session.git_branch ?? null,
            commitMessage: session.git_commit_message ?? null,
            tag: session.git_tag ?? null
        };
    }
    // Priority 3: datetime fallback (created_at is always present)
    return { type: 'datetime', value: session.created_at };
}
//# sourceMappingURL=getSessionDisplayName.js.map